export const API_GET_ALL_ROADS = "API_GET_ALL_ROADS";
export const API_GET_ALL_ROADS_SUCCESS = "API_GET_ALL_ROADS_SUCCESS";
export const API_GET_ALL_ROADS_FAIL = "API_GET_ALL_ROADS_FAIL";
